/* eslint-disable import/no-named-as-default-member */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  filteredData,
  processFormParticipantsData,
  processSummaryTshirtCount,
} from './utils'
import { FormParticipant, Participant as ParticipantApi } from '../API'
import { fetchQuery } from '../utils/ApiUtils'

type Participant = Omit<Exclude<ParticipantApi, null>, '__typename'>

export interface QueryInfo {
  queryName: string
  query: any
  variables: any
  isFormParticipant?: boolean
}

/**
 * Shared pagination loop for participant listing functions.
 * Accepts query info (already resolved for form/non-form) and handles
 * while-loop pagination, item processing, error fallback, and shirt aggregation.
 */
export async function paginateParticipants({
  queryInfo: { queryName, query, variables, isFormParticipant = false },
  isFree = false,
  startTimestamp = '',
}: {
  queryInfo: QueryInfo
  isFree?: boolean
  startTimestamp?: string
}) {
  let nextNextToken = ''
  let nextNextShirtTotal = {}
  let hasNext = true
  let data: any[] = []
  const formEventCategories: Record<string, string> = {}

  const fetchData = async (currentToken: string, currentShirtTotal: any) => {
    try {
      const { items, nextToken: newNextToken } = (await fetchQuery(
        queryName,
        query,
        {
          ...variables,
          ...(currentToken && currentToken.length > 0 && { nextToken: currentToken }),
        },
      )) as unknown as {
        items: Participant[] | FormParticipant[]
        nextToken: string
      }

      let newItems: any[] = []
      let shirtTotal = {}

      if (isFormParticipant) {
        const first = items[0] as any
        if (first?.formEvent?.categories?.items) {
          first.formEvent.categories.items.forEach((a: any) => {
            formEventCategories[a.id] = a.name
          })
        }
        const processedData = processFormParticipantsData(
          items,
          currentShirtTotal,
          formEventCategories,
        )
        newItems = processedData.items
        shirtTotal = processedData.tshirtTotal
      } else {
        newItems = filteredData(items, startTimestamp, isFree)
      }

      return { items: newItems, nextToken: newNextToken, nextShirtTotal: shirtTotal }
    } catch (e: any) {
      console.log(e)
      if ('data' in e) {
        const errData = e.data as any
        const newItems = filteredData(
          errData[queryName]?.items || errData[queryName + ' ']?.items,
          startTimestamp,
          isFree,
        )
        return {
          items: newItems,
          nextToken: errData[queryName]?.nextToken || errData[queryName + ' ']?.nextToken,
        }
      }
      return null
    }
  }

  while (hasNext) {
    const result = await fetchData(nextNextToken, nextNextShirtTotal)
    if (result) {
      data = [...data, ...result.items]
      nextNextToken = result.nextToken
      nextNextShirtTotal = result.nextShirtTotal || nextNextShirtTotal
      if (result.nextToken === null) hasNext = false
    } else {
      hasNext = false
    }
  }

  return {
    shirtTotal: processSummaryTshirtCount(nextNextShirtTotal, formEventCategories),
    participants: data,
  }
}
